import { useRef, useState, useEffect } from "react"

import { Carousel } from "antd"
import styles from "../index.module.less"
import { classModuleGenerator } from "@/utils"
const classnames = classModuleGenerator(styles)

function Environment({ photos = [] }) {
  const carouselRef = useRef()
  const [curSelected, setCurSelected] = useState({})

  useEffect(() => {
    if (photos.length) setCurSelected(photos[0])
  }, [photos])

  return (
    <section className={classnames("environment-container")}>
      <h3 className="section__title">学大全日制教学环境</h3>
      <h5 className="section__stitle">
        学大教育致力于打造无手机，无干扰，无顾虑，无霸凌及无隐患的校区环境，努力给学生塑造安静舒心的学习环境
      </h5>
      <div className="section__inner">
        <ul className={classnames("categorys")}>
          {photos.map((m) => {
            return (
              <li
                key={m._id}
                onClick={() => setCurSelected(m)}
                className={
                  m._id === curSelected._id ? classnames("selected") : ""
                }
              >
                {m.name}
              </li>
            )
          })}
        </ul>
        {curSelected && (
          <div className={classnames("envirs")}>
            {(curSelected.childs || []).length > 3 && (
              <>
                <div
                  className={classnames("slick-prev")}
                  onClick={() => {
                    carouselRef.current.prev()
                  }}
                >
                  <img
                    src={require("@/assets/images/icon_arrow_left.png")}
                    alt=""
                  />
                </div>
                <div
                  className={classnames("slick-next")}
                  onClick={() => {
                    carouselRef.current.next()
                  }}
                >
                  <img
                    src={require("@/assets/images/icon_arrow_right.png")}
                    alt=""
                  />
                </div>
              </>
            )}
            <Carousel
              autoplay={false}
              dots={false}
              ref={carouselRef}
              slidesToShow={
                (curSelected.childs || []).length < 3
                  ? (curSelected.childs || []).length
                  : 3
              }
              slidesToScroll={1}
            >
              {(curSelected.childs || []).map((m) => {
                return (
                  <div key={m._id}>
                    <div className={classnames("envirs-item")}>
                      <div className={classnames("pic-wrap")}>
                        <img
                          key={m._id}
                          className={classnames("envirs-pic")}
                          src={m.coverUrl}
                          alt=""
                        />
                      </div>
                      <h5>{m.name}</h5>
                      <p>{m.intro}</p>
                    </div>
                  </div>
                )
              })}
            </Carousel>
          </div>
        )}

        {/* <ul className={classnames("teaching-toplist", "clearfix")}>
          {topList.map((model) => {
            return (
              <li
                key={model.name}
                onClick={() => {
                  window.openJesongChatByGroup(121, 52601)
                  return false
                }}
              >
                <h4>{model.name}</h4>
                <p>{model.desc}</p>
              </li>
            )
          })}
        </ul>
        <ul className={classnames("teaching-bottomlist", "clearfix")}>
          {bottomList.map((model) => {
            return (
              <li
                key={model.desc}
                onClick={() => {
                  window.openJesongChatByGroup(121, 52601)
                  return false
                }}
              >
                <h4>{model.name}</h4>
                {model.desc.map((text) => (
                  <p key={text}>{text}</p>
                ))}
              </li>
            )
          })}
        </ul> */}
      </div>
    </section>
  )
}

export default Environment
